@layer legacy {
    .container {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        font-family: var(--sans-serif);
    }

    .label:not(:global(.tsqd-parent-container) *) {
        font-size: 1.6rem;
        font-weight: 400;
        line-height: 1.25;
        color: var(--ink);
        margin-bottom: 0.8rem;
    }

    .textarea {
        min-height: 84px;
        border-radius: var(--border-radius);
        border: solid 1px var(--ink-lighter);
        background-color: var(--white);
        font-family: var(--sans-serif);
        padding: 8px 16px;
        font-size: 1.6rem;
        resize: vertical;
    }

    .textarea:focus-visible {
        outline: none;
    }

    .textarea:hover {
        border-color: var(--ink-light);
    }

    .textarea:focus:not(.error) {
        box-shadow: 0 0 5px 0 rgba(18, 184, 134, 0.5);
        border: solid 1px var(--lime);
    }

    .textarea::placeholder {
        color: var(--ink-lighter);
        font-family: var(--sans-serif);
    }

    .textarea:disabled {
        border-color: var(--ink-lighter);
        background-color: var(--paper-dark);
    }

    .error,
    .error:hover {
        border-color: var(--red);
    }

    .errorText {
        color: var(--red);
    }
}
